// React stuff
window._ = require('lodash');
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.validateStatus = status => status >= 200 && status < 500; //only consider 500 and above as true errors

// jQuery stuff
window.$ = window.jQuery = require('jquery');
import 'jquery-ui/ui/widgets/datepicker.js';
import 'autonumeric';

// Bootstrap stuff
window.Popper = require('popper.js');
import 'bootstrap';

// htmx
import 'htmx.org';